<div class="d-flex align-items-center">
  @if (control) {
    <ng-container *ngTemplateOutlet="withFormControl"></ng-container>
  } @else {
    <mat-checkbox
      class="{{checkBoxOffset}}"
      [color]="'primary'"
      [checked]="value"
      (indeterminateChange)="onLabelClick()"
      (change)="onLabelClick()"
      [disabled]="disabled"
    ></mat-checkbox>
  }

  <label class="form-check-label {{labelClasses}} cursor-pointer" 
    [matTooltip]="showTooltip && nameInput"
    [matTooltipPosition]="'above'"
    (click)="onLabelClick()">{{nameInput}}
  </label>
</div>

<ng-template #withFormControl>
  <mat-checkbox
    class="{{checkBoxOffset}}"
    [formControl]="control"
    [color]="'primary'"
    [disabled]="disabled"
  ></mat-checkbox>
</ng-template>

